import { useQuery } from "react-query";
import { fetchPatientEncounters } from "@/services/encounters";
/** Query hook for the first page of a patient's clinical encounters, with filters. */
export function usePatientEncounters(workspaceId, patientId, filters) {
  return useQuery(["patient-encounters", workspaceId, patientId, filters !== null && filters !== void 0 ? filters : {}], function () {
    return fetchPatientEncounters(workspaceId, patientId, 1, filters);
  }, {
    enabled: Boolean(workspaceId && patientId),
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000,
    retryOnMount: false,
    notifyOnChangeProps: "tracked"
  });
}